module.exports = __webpack_public_path__ + "static/img/sy_hs2.a39cad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/sy_hs2.png
// module id = k8ik
// module chunks = 1